import { useEffect } from 'react';

import { App } from '@capacitor/app';
import { useNavigate } from 'react-router-dom';

// https://capacitorjs.com/docs/guides/deep-links#details-website-configuration
// https://developers.google.com/digital-asset-links/tools/generator
const DeepLinksListener = () => {
  const navigate = useNavigate();

  useEffect(() => {
    App.addListener('appUrlOpen', (event) => {
      const route = event.url.split('.app').pop();
      if (route) {
        navigate(route);
      }
    });
  }, []);
};

export default DeepLinksListener;
